export var StringFilterMode;
(function (StringFilterMode) {
    StringFilterMode["Insensitive"] = "insensitive";
    StringFilterMode["Sensitive"] = "sensitive";
})(StringFilterMode || (StringFilterMode = {}));
export var FilterCondition;
(function (FilterCondition) {
    FilterCondition["contains"] = "contains";
    FilterCondition["lessThan"] = "lessThan";
    FilterCondition["equals"] = "equals";
    FilterCondition["greaterThan"] = "greaterThan";
    FilterCondition["notEqual"] = "notEqual";
    FilterCondition["inRange"] = "inRange";
    FilterCondition["blank"] = "blank";
    FilterCondition["notBlank"] = "notBlank";
    FilterCondition["notContains"] = "notContains";
    FilterCondition["startsWith"] = "startsWith";
    FilterCondition["endsWith"] = "endsWith";
    FilterCondition["lessThanOrEqual"] = "lessThanOrEqual";
    FilterCondition["greaterThanOrEqual"] = "greaterThanOrEqual";
    FilterCondition["in"] = "in";
})(FilterCondition || (FilterCondition = {}));
export var FilterOperator;
(function (FilterOperator) {
    FilterOperator["AND"] = "AND";
    FilterOperator["OR"] = "OR";
})(FilterOperator || (FilterOperator = {}));
export var FilterValueType;
(function (FilterValueType) {
    FilterValueType["text"] = "text";
    FilterValueType["number"] = "number";
    FilterValueType["date"] = "date";
})(FilterValueType || (FilterValueType = {}));
//# sourceMappingURL=filter.types.js.map